export default defineNuxtRouteMiddleware((to) => {
  const isClient = import.meta.client

  // CRITICAL: Check for OAuth params FIRST, before any other logic
  if (isClient && typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search)
    const hashParams = new URLSearchParams(window.location.hash.substring(1))

    // Check both query string and hash for OAuth parameters
    const hasOAuthParams =
      (searchParams.has('code') && searchParams.has('state')) || (hashParams.has('code') && hashParams.has('state'))

    // If OAuth callback is present, STOP ALL PROCESSING and let app.vue handle it
    if (hasOAuthParams) {
      return
    }
  }

  // Check both user authentication state AND the presence of a bearer token.
  // The user store's isAuthenticated is persisted in cookies and can become
  // stale (true) while the actual tokens have been cleared. Checking both
  // prevents the redirect loop where middleware sends an unauthenticated
  // user away from /login.
  const { isAuthenticated } = useUserStore()
  const { bearerToken } = useAuthStore()
  const effectivelyAuthenticated = isAuthenticated && Boolean(bearerToken)

  // Define public routes that don't require authentication
  const publicRoutes = [
    '/login',
    '/admin-token',
    '/register',
    '/forgot-password',
    '/forgot-username',
    '/reset-password',
    '/user/account/activate'
  ]

  const isPublicRoute = (path: string) => {
    return publicRoutes.includes(path) || path.startsWith('/activation/')
  }

  // If not effectively authenticated and trying to access a protected route, redirect to login
  if (!effectivelyAuthenticated && !isPublicRoute(to.path)) {
    // If we have a stale isAuthenticated flag, clean it up
    if (isAuthenticated && !bearerToken) {
      const userStore = useUserStore()
      userStore.clearAuth()
    }

    return navigateTo({
      path: '/login',
      query: {
        redirect: to.path === '/' || to.path === '/home' || to.path === '/login' ? undefined : to.fullPath
      }
    })
  }

  // If authenticated and trying to access login or register, redirect to home
  if (effectivelyAuthenticated && ['/login', '/register'].includes(to.path)) {
    return navigateTo('/home')
  }
})
